export default "__VITE_ASSET__CM0db8Iq__"